var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32493)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32493)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.144 -4.48597C265.515 -10.7355 282.244 -12.704 291.535 10.0964C316.157 10.1334 320.621 26.3756 318.726 38.3371C317.306 47.3068 305.951 57.3064 299.743 61.9494L264.573 89.1232C263.223 90.1656 261.269 89.1751 261.312 87.471L261.765 69.5715C261.952 62.1753 254.396 57.0868 247.612 60.0401L231.118 67.2215C229.569 67.896 227.949 66.5034 228.425 64.8821C231.317 55.0313 237.39 35.8941 240.399 21.9819C243.898 5.80868 246.782 0.553511 255.144 -4.48597Z",
    stroke: "#5D94E8",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 108,
    cy: -19,
    r: 101.5,
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: -18,
    cy: -22,
    r: 101.5,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M199.5 -19C199.5 31.5341 158.534 72.5 108 72.5C57.4659 72.5 16.5 31.5341 16.5 -19C16.5 -69.5341 57.4659 -110.5 108 -110.5C158.534 -110.5 199.5 -69.5341 199.5 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M189.5 -19C189.5 26.0112 153.011 62.5 108 62.5C62.9888 62.5 26.5 26.0112 26.5 -19C26.5 -64.0112 62.9888 -100.5 108 -100.5C153.011 -100.5 189.5 -64.0112 189.5 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M178.5 -19C178.5 19.9361 146.936 51.5 108 51.5C69.0639 51.5 37.5 19.9361 37.5 -19C37.5 -57.9361 69.0639 -89.5 108 -89.5C146.936 -89.5 178.5 -57.9361 178.5 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M168.5 -19C168.5 14.4132 141.413 41.5 108 41.5C74.5868 41.5 47.5 14.4132 47.5 -19C47.5 -52.4132 74.5868 -79.5 108 -79.5C141.413 -79.5 168.5 -52.4132 168.5 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M158.5 -19C158.5 8.89037 135.89 31.5 108 31.5C80.1096 31.5 57.5 8.89037 57.5 -19C57.5 -46.8904 80.1096 -69.5 108 -69.5C135.89 -69.5 158.5 -46.8904 158.5 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "#5D94E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32493",
    x1: -0.00000178282,
    y1: 31.7143,
    x2: 294.149,
    y2: 141.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D7FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalBackground);
export default __webpack_public_path__ + "static/media/DentalBackground.f76a846b978be010cc83fd40bdbe2271.svg";
export { ForwardRef as ReactComponent };